import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Router} from "@angular/router";
import {ActivatedRoute} from "@angular/router";
import {UploaderOptions, UploadFile, UploadInput, UploadOutput} from "ngx-uploader";
import {environment} from "../../../environments/environment";
import {Requirement} from "../../models/requirement";
import {AuthService} from "../../services/auth/auth-service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: "file-uploader",
  templateUrl: "file-uploader.component.html",
})
export class FileUploaderComponent {

  @Input() public item: Requirement;
  @Output() public fileIdChanged: EventEmitter<string>;
  private baseUrl: string = environment.BASE_URL;
  public serviceId: string;
  public options: UploaderOptions;
  public formData: FormData;
  public files: UploadFile[];
  public uploadInput: EventEmitter<UploadInput>;
  public dragOver: boolean;

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, private toastr: ToastrService) {
    this.options = {concurrency: 1, maxUploads: 3, maxFileSize: environment.UPLOAD_MAX_FILE_SIZE};
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.fileIdChanged = new EventEmitter<string>();
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
    });
  }

  public error(message: string, title: string) {
    this.toastr.toastrConfig.closeButton = true;
    this.toastr.toastrConfig.timeOut = 0;
    this.toastr.toastrConfig.extendedTimeOut = 0;
    this.toastr.toastrConfig.tapToDismiss = false;
    this.toastr.error(message, title);
  }

  public onUploadOutput(output: UploadOutput): void {
    if (output.type === "allAddedToQueue") {
      this.startUpload();
    } else if (output.type === "rejected") {
      if (output.file) {
        if (output.file.size > environment.UPLOAD_MAX_FILE_SIZE) {
          this.error("Upload file size is limit", "Upload");
        }
      }
    } else if (output.file && output.file.response) {
      this.fileIdChanged.emit(output.file.response);
    }
  }

  private startUpload(): void {
    this.authService.getToken().then((token) => {
      const event: UploadInput = {
        type: "uploadAll",
        url: this.baseUrl + "service/" + this.serviceId + "/file",
        headers: {Authorization: "Bearer " + token},
        method: "POST",
      };
      this.uploadInput.emit(event);
    });
  }
}
